
import { CrownOutlined } from '@ant-design/icons';
import {Tag,Tooltip } from 'antd';


const CrownReturn = ({premiumUser}) =>{
    if(premiumUser) 
    return <CrownOutlined />

    return <Tooltip title="Upgrade your plan to access this feature" style={{cursor:'pointer'}}><Tag icon={<CrownOutlined style={{fontSize:'16px'}} /> } color="purple" ></Tag></Tooltip>
}

export default CrownReturn;